module.exports = __webpack_public_path__ + "static/media/sort-icon-up.3f5f1a0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort-icon-up.svg
// module id = 488
// module chunks = 1